module.exports = __webpack_public_path__ + "static/media/DSC06584.a12bbe41.png";